import { render } from "./UploadFile.vue?vue&type=template&id=5f9cd5ef&scoped=true"
import script from "./UploadFile.vue?vue&type=script&lang=js"
export * from "./UploadFile.vue?vue&type=script&lang=js"

import "./UploadFile.vue?vue&type=style&index=0&id=5f9cd5ef&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f9cd5ef"],['__file',"src/components/UploadFile/UploadFile.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5f9cd5ef"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5f9cd5ef', __exports__)) {
    api.reload('5f9cd5ef', __exports__)
  }
  
  module.hot.accept("./UploadFile.vue?vue&type=template&id=5f9cd5ef&scoped=true", () => {
    api.rerender('5f9cd5ef', render)
  })

}


export default __exports__